import api from "../api";

function obter(worspaceId, reportId) {
 
  return new Promise((resolve, reject) => {
    return api
      .get(`/obterEmbedToken?workspaceId=${worspaceId}&&reportId=${reportId}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default {
  obter
};
